
import React, { memo } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ComplianceDocument } from '@/types/compliance';

interface DocumentSelectorProps {
  documents: ComplianceDocument[];
  selectedDocumentId: string;
  onDocumentChange: (id: string) => void;
}

const DocumentSelector = memo(({ 
  documents, 
  selectedDocumentId, 
  onDocumentChange 
}: DocumentSelectorProps) => {
  return (
    <div className="w-full">
      <Select value={selectedDocumentId} onValueChange={onDocumentChange}>
        <SelectTrigger className="w-full h-14 text-lg">
          <SelectValue placeholder="Select a document" />
        </SelectTrigger>
        <SelectContent>
          {documents.map((doc) => (
            <SelectItem key={doc.id} value={doc.id}>
              {doc.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
});

DocumentSelector.displayName = 'DocumentSelector';

export default DocumentSelector;
